// src/resizeObserverFix.js

if (typeof window !== "undefined") {
    const originalError = console.error;
    console.error = (...args) => {
      if (
        args.length > 0 &&
        typeof args[0] === "string" &&
        args[0].includes("ResizeObserver loop")
      ) {
        return;
      }
      originalError(...args);
    };
  
    window.addEventListener("error", (e) => {
      if (e.message?.includes("ResizeObserver loop")) {
        e.stopImmediatePropagation();
      }
    });
  
    window.addEventListener("unhandledrejection", (e) => {
      if (e.reason?.message?.includes("ResizeObserver loop")) {
        e.stopImmediatePropagation();
      }
    });
  }
  